import { render } from "./insertTextModal.vue?vue&type=template&id=54d21b05&ts=true"
import script from "./insertTextModal.vue?vue&type=script&lang=ts"
export * from "./insertTextModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__